// extracted by mini-css-extract-plugin
var _1 = "Q0vsI";
export { _1 as "categoryMenu" }
